import React from 'react';

import { BaseOrderView } from 'views/BaseOrderView';

import {
  SberQrLayout,
  SberQrPaymentDetails,
  SberQrPaymentLoading,
  SberQrPaymentStatus,
} from './components';

export const SberQrOrderView: React.FC = () => (
  <BaseOrderView
    overrideComponents={{
      Layout: SberQrLayout,
      PaymentDetails: SberQrPaymentDetails,
      PaymentLoading: SberQrPaymentLoading,
      PaymentStatus: SberQrPaymentStatus,
    }}
  />
);
